import { z } from "zod";
const PAGE_LIMIT_DEFAULT = 50;
const PAGE_LIMIT_MAX = 200;
const PageQuerySchema = z.strictObject({
  limit: z.coerce.number().int().min(1).max(PAGE_LIMIT_MAX).default(PAGE_LIMIT_DEFAULT),
  cursor: z.string().min(1).max(512).optional()
});
function pageOf(item) {
  return z.strictObject({
    items: z.array(item).max(PAGE_LIMIT_MAX),
    nextCursor: z.string().nullable()
  });
}
export {
  PAGE_LIMIT_DEFAULT,
  PAGE_LIMIT_MAX,
  PageQuerySchema,
  pageOf
};
//# sourceMappingURL=pagination.js.map